/**
 * OVERRIDE View.jsx
 * REASON: Use align:noprefix and blockWidth:noprefix CSS custom properties instead of align class.
 * DATE: 2026-04-16
 * DEVELOPER: @danalvrz
 */

import MapsView from '../../../../../../components/Blocks/Maps/View';

export default MapsView;
